import React from 'react'
import { useParams } from 'react-router-dom'
import { Divider, Stack } from '@mui/material'

import { useGetMaterialTypeQuery } from 'services/materialTypes'
import { useGetPriceEntryHistoryByMaterialIdQuery } from 'services/priceEntries'

import BasicDataGrid from 'components/generic/datagrid'
import { useMaterialHeader } from 'components/containers/commodities/useMaterialHeader'
import useGlobalLoader from 'utils/custom-hooks/useGlobalLoader'
import { PAGE_SIZE } from 'utils/constants'

const MaterialPricingContainer = () => {
  const { materialId: materialTypeId } = useParams()
  const { data: materialTypeData, isFetching: isFetchingMaterialType } = useGetMaterialTypeQuery({ materialTypeId })
  const { data: priceHistory, isFetching: isFetchingPriceSheets } = useGetPriceEntryHistoryByMaterialIdQuery({
    materialTypeId,
  })

  useMaterialHeader(materialTypeData)
  useGlobalLoader(isFetchingMaterialType || isFetchingPriceSheets)

  const columns = [
    {
      field: 'priceType',
      headerName: 'Price Type',
      flex: 1,
      renderCell: params => <span style={{ textTransform: 'capitalize' }}>{params.row.priceType}</span>,
    },
    {
      field: 'newPrice',
      headerName: 'New Price',
      flex: 1,
      renderCell: params => (params.row?.newPrice || params.row?.newPrice === 0 ? `$${params.row.newPrice}` : '---'),
    },
    {
      field: 'oldPrice',
      headerName: 'Old Price',
      flex: 1,
      renderCell: params => (params.row?.oldPrice || params.row?.oldPrice === 0 ? `$${params.row.oldPrice}` : '---'),
    },
    {
      field: 'date',
      headerName: 'Date Changed',
      type: 'date',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
    },
  ]
  const rows = priceHistory
    ?.map(h => ({
      id: h.id,
      priceType: `${h.priceEntry?.priceSheet?.type} ${h.priceEntry?.isBuyPrice ? 'buy' : 'sell'}`.toLowerCase(),
      newPrice: h.newPrice,
      oldPrice: h.oldPrice,
      date: new Date(h.date),
    }))
    .sort((a, b) => b.date - a.date)

  return (
    <Stack padding={3}>
      {/* TODO Current Pricing */}
      <Stack>
        <h3 color="text.secondary">Pricing History Change Log</h3>
        <Divider />
        <BasicDataGrid columns={columns} rows={rows} pagination pageSize={PAGE_SIZE} />
      </Stack>
    </Stack>
  )
}

export default MaterialPricingContainer
